export const createHubUserEmailOptionsForSelect = hubUsers => hubUsers.reduce((hash, user) => {
  const emailAddress = user.get('email');
  hash.push({
    text: emailAddress,
    value: emailAddress
  });
  return hash;
}, []);